import { Link } from "react-router-dom";

const ProfileNav = ({ activeRoute }: any) => {
  const navItems = [
    { route: "/profile/info", title: "اطلاعات من" },
    { route: "/profile/notifications", title: "پیام ها" },
    { route: "/profile/addresses", title: "آدرس ها" },
    { route: "/profile/orders", title: "سفارشات" },
  ];

  return (
    <div className='flex'>
      {navItems.map((item) => (
        <Link
          key={item.route}
          className={`p-2 px-3 font-bold ${
            activeRoute === item.route &&
            " border-b border-rose-900 text-rose-900 border-b-2"
          }`}
          to={item.route}
        >
          {item.title}
        </Link>
      ))}
    </div>
  );
};

export default ProfileNav;
